enum ROUTE {
    MAIN = '/',
    ONLINE_QUES = '/online-ques',
    CUSTOMERS_SETTING = '/customers',
    CUSTOMERS = '/customers/manage-customers',
    CUSTOMERS_NEW = '/customers/manage-customers/new',
    CUSTOMERS_EDIT = '/customers/manage-customers/:id',
    CUSTOMERS_CATEGORIES = '/customer-categories',
    CUSTOMERS_CATEGORIES_MAIN = '/customer-categories/manage-categories',
    CUSTOMERS_CATEGORIES_NEW = '/customer-categories/manage-categories/new',
    CUSTOMERS_CATEGORIES_EDIT = '/customer-categories/manage-categories/:id',
    CUSTOMERS_LOYALTY = '/customer-loyalty',
    CUSTOMERS_LOYALTY_MANAGEMENT = '/customer-loyalty/loyalty-management',
    CUSTOMERS_LOYALTY_HISTORY = '/customer-loyalty/loyalty-history',
    USER_PREFERENCE = '/user-preferences',
    USER_PREFERENCE_SECURITY = '/user-preferences/security',
    USER_PREFERENCE_DISPLAY = '/user-preferences/display',
    QUESTION = '/question',
    LOCATION_SETTING = '/system-settings',
    SYSTEM_SETTING_GENERAL = '/system-settings/general',
    SYSTEM_SETTING_OW_MODULES = '/system-settings/orderwire-modules',
    SYSTEM_SETTING_FULFILLMENT_OPTIONS = '/system-settings/fulfillment-options',
    SYSTEM_SETTING_EVENT_ROUTE_SETTINGS = '/system-settings/order-event-routes-settings',
    SYSTEM_SETTING_EVENT_ROUTE_SETTINGS_NEW = '/system-settings/order-event-routes-settings/new',
    SYSTEM_SETTING_EVENT_ROUTE_SETTINGS_EDIT = '/system-settings/order-event-routes-settings/:id',
    SYSTEM_SETTING_RESET_SALES = '/system-settings/reset-sales',

    DEVICE_TERMINAL = '/terminal-devices',
    DEVICE_TERMINAL_POS = '/terminal-devices/pos-terminals',
    DEVICE_TERMINAL_POS_NEW = '/terminal-devices/pos-terminals/new',
    DEVICE_TERMINAL_POS_EDIT = '/terminal-devices/pos-terminals/:id',
    DEVICE_TERMINAL_POS_VIEW_CONNECTIVITY = '/terminal-devices/pos-terminal-connectivity',
    DEVICE_TERMINAL_ORDER_QUES = '/terminal-devices/order-que-terminals',
    DEVICE_TERMINAL_ORDER_QUES_EDIT = '/terminal-devices/order-que-terminals/:id',

    DEVICE_PRINTERS = '/printers',
    DEVICE_PRINTERS_MAIN = '/printers/printers',

    DEVICE_HARDWARE_AGENTS = '/hardware-agents',
    DEVICE_HARDWARE_AGENTS_MAIN = '/hardware-agents/hardware-agents',

    DEVICE_INTEGRATIONS = '/device-integrations',
    DEVICE_INTEGRATIONS_NOTIFICATIONS = '/device-integrations/notification',
    DEVICE_INTEGRATIONS_NOTIFICATIONS_EDIT = '/device-integrations/notification/:id',
    DEVICE_INTEGRATIONS_KDS_INTEGRATIONS = '/device-integrations/kds-integrations',
    DEVICE_INTEGRATIONS_KDS_INTEGRATIONS_EDIT = '/device-integrations/kds-integrations/:id',
    DEVICE_INTEGRATIONS_CUSTOMER_FACING_DISPLAYS = '/device-integrations/customer-facing-displays',
    DEVICE_INTEGRATIONS_CUSTOMER_FACING_DISPLAY_NEW = '/device-integrations/customer-facing-displays/new',
    DEVICE_INTEGRATIONS_CUSTOMER_FACING_DISPLAY_EDIT = '/device-integrations/customer-facing-displays/:id',

    SYSTEM_SETTING_INTEGRATION_ORDER_CHANNEL = '/system-settings/integration/order-channel',
    SYSTEM_SETTING_BRANDS = '/system-settings/brands',
    FINANCIAL = '/financials',
    FINANCIAL_GENERAL = '/financials/general',
    FINANCIAL_COMPANY_DETAIL = '/financials/company-details',
    FINANCIAL_TAXES = '/taxes',
    FINANCIAL_TAXES_SETTING = '/taxes/tax-setting',
    FINANCIAL_TAXES_SETTING_NEW = '/taxes/tax-setting/new',
    FINANCIAL_TAXES_SETTING_EDIT = '/taxes/tax-setting/:id',
    FINANCIAL_TAXES_SETTING_SINGLE_TAX = '/taxes/tax-setting/single',
    FINANCIAL_TAXES_SETTING_SINGLE_TAX_EDIT = '/taxes/tax-setting/single/:id',
    FINANCIAL_TAXES_SETTING_COMBINED_TAX = '/taxes/tax-setting/combined',
    FINANCIAL_TAXES_SETTING_COMBINED_TAX_EDIT = '/taxes/tax-setting/combined/:id',
    FINANCIAL_TAXES_PRODUCT_TAXES = '/taxes/product-taxes',
    FINANCIAL_ACCOUNTING_CODES = '/financials/accounting-codes',
    FINANCIAL_ACCOUNTING_CODES_GLCODES = '/financials/accounting-codes/gl-codes',
    FINANCIAL_ACCOUNTING_CODES_GLCODES_NEW = '/financials/accounting-codes/gl-codes/new',
    FINANCIAL_ACCOUNTING_CODES_GLCODES_EDIT = '/financials/accounting-codes/gl-codes/:id',
    FINANCIAL_ACCOUNTING_CODES_GLCODE_TYPES = '/financials/accounting-codes/gl-code-types',
    FINANCIAL_ACCOUNTING_CODES_GLCODE_TYPES_NEW = '/financials/accounting-codes/gl-code-types/new',
    FINANCIAL_ACCOUNTING_CODES_GLCODE_TYPES_EDIT = '/financials/accounting-codes/gl-code-types/:id',
    FINANCIAL_ACCOUNTING_CODES_GLCODE_MAPS = '/financials/accounting-codes/gl-code-maps',
    FINANCIAL_ACCOUNTING_CODES_GLCODE_MAPS_NEW = '/financials/accounting-codes/gl-code-maps/new',
    FINANCIAL_ACCOUNTING_CODES_GLCODE_MAPS_EDIT = '/financials/accounting-codes/gl-code-maps/:id',

    PAYMENT_METHODS = '/payment-methods',
    PAYMENT_METHODS_POS_PAYMENTS = '/payment-methods/pos-payments',
    PAYMENT_METHODS_POS_PAYMENTS_EDIT = '/payment-methods/pos-payments/:id',
    PAYMENT_METHODS_SYSTEM_PAYMENTS = '/payment-methods/system-payment-methods',
    PAYMENT_METHODS_CUSTOM_PAYMENTS = '/payment-methods/custom-payment-methods',
    PAYMENT_METHODS_CUSTOM_PAYMENTS_NEW = '/payment-methods/custom-payment-methods/new',
    PAYMENT_METHODS_CUSTOM_PAYMENTS_EDIT = '/payment-methods/custom-payment-methods/:id',
    PAYMENT_METHODS_INTEGRATIONS_PAYMENTS = '/payment-methods/payment-integrations',
    PAYMENT_METHODS_PAYMENT_DEVICES = '/payment-methods/payment-devices',

    FINANCIAL_SERVICE_CHARGES = '/financials/service-charges',
    VENDOR = '/vendors',
    VENDOR_PROFILE = '/vendors/vendors',
    VENDOR_PROFILE_NEW = '/vendors/vendors/new',
    VENDOR_PROFILE_EDIT = '/vendors/vendors/:id',

    POS_MENUS = '/pos-menus',
    POS_MENUS_MENUS = '/pos-menus/menus',
    POS_MENUS_MENUS_NEW = '/pos-menus/menus/new',
    POS_MENUS_MENUS_EDIT = '/pos-menus/menus/:id',
    POS_MENUS_MENUS_VIEW = '/pos-menus/menu-view',

    POS_SETTINGS = '/pos-settings',
    POS_SETTINGS_GENERAL = '/pos-settings/general',
    POS_SETTINGS_SERVICE_CHARGE = '/pos-settings/service-charge',
    POS_SETTINGS_TIPS_SETTINGS = '/pos-settings/tips-settings',

    POS_CONDITIONS = '/pos-conditions',
    POS_CONDITIONS_ORDER_NUMBERING = '/pos-conditions/order-numbering',
    POS_CONDITIONS_VOID_COMP_REASONS = '/pos-conditions/void-comp-reasons',
    POS_CONDITIONS_VOID_COMP_REASONS_NEW = '/pos-conditions/void-comp-reasons/new',
    POS_CONDITIONS_VOID_COMP_REASONS_EDIT = '/pos-conditions/void-comp-reasons/:id',
    POS_CONDITIONS_REFUND_REASONS = '/pos-conditions/refund-reasons',
    POS_CONDITIONS_REFUND_REASONS_NEW = '/pos-conditions/refund-reasons/new',
    POS_CONDITIONS_REFUND_REASONS_EDIT = '/pos-conditions/refund-reasons/:id',
    POS_CONDITIONS_PAYINPAYOUTREASONS = '/pos-conditions/payin-payout-reasons',
    POS_CONDITIONS_PAYINPAYOUTREASONS_NEW = '/pos-conditions/payin-payout-reasons/new',
    POS_CONDITIONS_PAYINPAYOUTREASONS_EDIT = '/pos-conditions/payin-payout-reasons/:id',

    POS_TABLE_LAYOUTS = '/table-layouts',
    POS_TABLE_LAYOUTS_MAIN = '/table-layouts/table-layouts',
    POS_TABLE_LAYOUTS_NEW = '/table-layouts/table-layouts/new',
    POS_TABLE_LAYOUTS_EDIT = '/table-layouts/table-layouts/:id',

    POS_SALES_PROCESSING = '/pos-sales-processing',
    POS_SALES_PROCESSING_GENERAL = '/pos-sales-processing/general-sale-rules',
    POS_SALES_PROCESSING_QS = '/pos-sales-processing/quick-service-rules',
    POS_SALES_PROCESSING_TS = '/pos-sales-processing/table-service-rules',
    POS_SALES_PROCESSING_ONLINE = '/pos-sales-processing/online-order-rules',

    ONLINE_MENU_BUILDER = '/online-menu-builder',
    ONLINE_MENU_BUILDER_MAIN = '/online-menu-builder/online-menu-builder',
    ONLINE_MENU_BUILDER_NEW = '/online-menu-builder/online-menu-builder/new',
    ONLINE_MENU_BUILDER_EDIT = '/online-menu-builder/online-menu-builder/:id',

    ONLINE_STORE = '/online-stores',
    ONLINE_STORE_ORDER_CHANNEL = '/online-stores/order-channels',
    ONLINE_STORE_ORDER_CHANNEL_NEW = '/online-stores/order-channels/new',
    ONLINE_STORE_ORDER_CHANNEL_EDIT = '/online-stores/order-channels/:id',
    ONLINE_STORE_MY_STORES = '/online-stores/online-stores',
    ONLINE_STORE_STORES_NEW = '/online-stores/online-stores/new',
    ONLINE_STORE_STORES_EDIT = '/online-stores/online-stores/:id',
    ONLINE_STORE_SETUP = '/online-stores/setup',

    ONLINE_INTEGRATIONS = '/online-integrations',
    ONLINE_INTEGRATIONS_MAIN = '/online-integrations/online-integrations',
    ONLINE_INTEGRATIONS_EDIT = '/online-integrations/online-integrations/:id',

    COMPANY_SETTING = '/company-setting',
    COMPANY_COMPANY_AND_LOCATION_PROFILE = '/company-setting/company-and-location-profile',
    COMPANY_BRANDS = '/company-setting/brands',
    COMPANY_BRANDS_NEW = '/company-setting/brands/new',
    COMPANY_BRANDS_EDIT = '/company-setting/brands/:id',
    COMPANY_LOCATIONS_NEW = '/company-setting/company-and-location-profile/new',
    COMPANY_LOCATIONS_EDIT = '/company-setting/company-and-location-profile/:id',
    COMPANY_SUBSCRIPTION = '/company-setting/subscription',

    PRODUCT_CATEGORIES = '/categories',
    PRODUCT_CATEGORIES_MAIN = '/categories/sales-categories',
    PRODUCT_CATEGORIES_NEW = '/categories/sales-categories/new',
    PRODUCT_CATEGORIES_EDIT = '/categories/sales-categories/:id',

    PRODUCT_INGREDIENTS = '/ingredients',
    PRODUCT_INGREDIENTS_MAIN = '/ingredients/ingredients',
    PRODUCT_INGREDIENTS_NEW = '/ingredients/ingredients/new',
    PRODUCT_INGREDIENTS_EDIT = '/ingredients/ingredients/:id',

    PRODUCT_COMBOS = '/combo-set',
    PRODUCT_COMBOS_MAIN = '/combo-set/combo-set',

    PRODUCT_COMBOS_NEW = '/combo-set/combo-set/new-combo',
    PRODUCT_COMBOS_EDIT = '/combo-set/combo-set/:id',

    PRODUCT = '/products',
    PRODUCT_PRODUCTS = '/products/products',
    PRODUCT_PRODUCTS_NEW = '/products/products/new',
    PRODUCT_PRODUCTS_EDIT = '/products/products/:id',
    PRODUCT_PRODUCTS_VARIANTS_EDIT = '/products/products/:id/variant/:variantId',
    PRODUCT_VARIANTS = '/products/variants',
    PRODUCT_VARIANTS_NEW_NEWER = '/products/variants/newer',
    PRODUCT_VARIANTS_EDIT_NEWER = '/products/variants/:id/newer',
    PRODUCT_VARIANTS_NEW = '/products/variants/new',
    PRODUCT_VARIANTS_EDIT = '/products/variants/:id',
    PRODUCT_MODIFIER_GROUPS = '/products/modifier-groups',
    PRODUCT_MODIFIER_GROUPS_NEW = '/products/modifier-groups/new',
    PRODUCT_MODIFIER_GROUPS_EDIT = '/products/modifier-groups/:id',
    PRODUCT_DEPOSIT_AND_CREDIT_PRODUCT = '/products/deposit-and-credit-products',
    PRODUCT_DEPOSIT_AND_CREDIT_PRODUCT_NEW = '/products/deposit-and-credit-products/new',
    PRODUCT_DEPOSIT_AND_CREDIT_PRODUCT_EDIT = '/products/deposit-and-credit-products/:id',

    INVENTORY = '/inventory',
    INVENTORY_ITEM = '/inventory/item-inventory',
    INVENTORY_EDIT = '/inventory/item-inventory/:id',
    INVENTORY_GIFTCARD = '/inventory/gift-card-inventory',

    INVENTORY_REPORT = '/inventory-report',
    INVENTORY_REPORT_HISTORY = '/inventory-report/inventory-history',
    INVENTORY_REPORT_COGS = '/inventory-report/cogs-report',

    UOM = '/units-of-measure',
    UOM_UOMS = '/units-of-measure/uoms',
    UOM_NEW = '/units-of-measure/uoms/new',
    UOM_EDIT = '/units-of-measure/uoms/:id',
    uom_categories = '/units-of-measure/uom-classes',

    USERS = '/users',
    USERS_USERS = '/users/users',
    USERS_USERS_NEW = '/users/users/new',
    USERS_USERS_EDIT = '/users/users/:id',
    USERS_ROLES = '/users/roles',
    USERS_ROLES_NEW = '/users/roles/new',
    USERS_ROLES_EDIT = '/users/roles/:id',
    USERS_NOTIFICATIONGROUP = '/users/notification-groups',
    USERS_NOTIFICATIONGROUP_NEW = '/users/notification-groups/new',
    USERS_NOTIFICATIONGROUP_EDIT = '/users/notification-groups/:id',
    LOGIN = '/login',
    LOGOUT = '/logout',
    FORGET = '/forget',
    REGISTER = '/register',
    QUICK_SERVICE = '/quick-service',
    TABLE_SERVICE = '/table-service',
    TABLE_SERVICE_RESERVATION = '/table-service/reservation',
    TABLE_SERVICE_POS = '/table-service/pos',
    ONLINE_ORDERS = '/online-orders',
    ONLINE_ORDERS_MY_ORDERS = '/online-orders/online-orders',
    NO_PERMISSION_ON_STARTUP_PAGE = '/no-permission',

    KITCHEN_DISPLAY = '/kitchen-display',
    ONLINE_SALES = '/online-sales',
    ORDER_QUES = '/order-ques',
    REPORTS = '/reports',
    DEVICE = '/device',
    PAYMENT = '/payments',
    TAX = '/tax',
    DISCOUNTS_SPECIALS_PROMOTIONS = '/discounts-specials-promotions',
    DISCOUNTS = '/discounts-specials-promotions/discounts',
    DISCOUNTS_NEW = '/discounts-specials-promotions/discounts/new',
    DISCOUNTS_EDIT = '/discounts-specials-promotions/discounts/:id',

    GIFTCARDS = '/gift-cards',
    GIFTCARDS_GIFTCARDS = '/gift-cards/manage-gift-cards',
    GIFTCARDS_GIFTCARDS_NEW = '/gift-cards/manage-gift-cards/new',
    GIFTCARDS_GIFTCARDS_EDIT = '/gift-cards/manage-gift-cards/:id',
    GIFTCARDS_ISSUE_GIFTCARDS = '/gift-cards/issue-gift-cards',
    GIFTCARDS_ISSUE_GIFTCARDS_NEW = '/gift-cards/issue-gift-cards/new',
    GIFTCARDS_ISSUE_GIFTCARDS_EDIT = '/gift-cards/issue-gift-cards/:id',
    GIFTCARDS_GIFTCARDS_SETTIGS = '/gift-cards/settings',

    SALES_REPORTS = '/sales-reports',
    SALES_REPORTS_MAIN = '/sales-reports/sales',
    SALES_SUMMARY_REPORTS = '/sales-reports/summary',
    SALES_GROWTH_REPORTS = '/sales-reports/growth',
    SALES_DISCOUNT_REPORTS = '/sales-reports/discount',
    SALES_EMPLOYEE_REPORTS = '/sales-reports/employee',
    SALES_CATEGORY_REPORTS = '/sales-reports/category',
    SALES_PRODUCT_REPORTS = '/sales-reports/product',
    SALES_PAYMENT_REPORTS = '/sales-reports/payments',

    EMPLOYEE_TIME_CLOCK = '/employee-time-clock',
    EMPLOYEE_TIME_CLOCK_SETTING = '/employee-time-clock/settings',
    EMPLOYEE_REPORT = '/employee-reports',
    EMPLOYEE_REPORT_TOTAL_HOURS = '/employee-reports/employee-hours',
    EMPLOYEE_REPORT_PERFORMANCE = '/employee-reports/employee-performance',
    EMPLOYEE_REPORT_TIMECLOCK = '/employee-reports/employee-timeclock',
    EMPLOYEE_TIME_CLOCK_MANAGEMENT = '/employee-time-clock/entry-management',
    EMPLOYEE_TIME_CLOCK_MANAGEMENT_NEW = '/employee-time-clock/entry-management/new',
    EMPLOYEE_TIME_CLOCK_MANAGEMENT_EDIT = '/employee-time-clock/entry-management/:id',

    ACCOUNTING_REPORTS = '/accounting-reports',
    ACCOUNTING_REPORTS_BALANCE = '/accounting-reports/balance',
    ACCOUNTING_REPORTS_JOURNAL = '/accounting-reports/journal',
    ACCOUNTING_REPORTS_ACCOUNTING = '/accounting-reports/accounting',
    ACCOUNTING_REPORTS_ACCOUNTING_BALANCE = '/accounting-reports/accounting-balance',
    ACCOUNTING_REPORTS_ACCOUNTING_LEDGER = '/accounting-reports/accounting-ledger',
    ACCOUNTING_REPORTS_PROFIT_LOSS = '/accounting-reports/profit-loss',

    TIME_CLOCK_POPUP = '/time-clock-popup',
    TIME_CLOCK_ONLY_MODE = '/time-clock-mode',
    BATCH = '/batch',
    SELECT_DEVICE = '/select-device',
    NOT_FOUND = '/not-found',
    RECEIPT_SETTINGS = '/receipt-settings',
    RECEIPT_SETTINGS_TEMPLATES = '/receipt-settings/receipt-templates',
    RECEIPT_SETTINGS_TEMPLATES_EDIT = '/receipt-settings/receipt-templates/:id',

    CASH_DRAWER_TERMINAL = '/cash-drawer',
    POS_TERMINAL = '/pos-terminal',

    CLOSE_OF_DAY = '/close-of-day',
    CLOSE_OF_DAY_PROCESS = '/close-of-day/close-of-day-process',
    CLOSE_OF_DAY_PROCESS_SUMMARY = '/close-of-day/closure-history/:id',
    CLOSE_OF_DAY_CLOSURE_HISTORY = '/close-of-day/closure-history',
    CLOSE_OF_DAY_CLOSING_PROCEDURE_SETTING = '/close-of-day/closing-procedure',

    REPORT_SETTINGS = '/report-settings',
    REPORT_SETTINGS_MAIN = '/report-settings/report-settings',

    TERMINAL_REPORTS = '/terminal-reports',
    TERMINAL_REPORTS_CLOSURE_HISTORY = '/terminal-reports/closure-history',
    TERMINAL_REPORTS_CLOSURE_HISTORY_REPORT = '/terminal-reports/closure-history/:id',

    FINANCIAL_PAYMENT_ACCOUNTS = '/financials/payment-accounts',
    FINANCIAL_PAYMENT_ACCOUNTS_NEW = '/financials/payment-accounts/new',
    FINANCIAL_PAYMENT_ACCOUNTS_EDIT = '/financials/payment-accounts/:id',
    TERMINAL_PREFERENCE = '/terminal-preferences',
    TERMINAL_PREFERENCE_PRINTING = '/terminal-preferences/printing',
    TERMINAL_PREFERENCE_PAYMENT = '/terminal-preferences/payment',
    TERMINAL_PREFERENCE_CUSTOMER_FACING_DISPLAY = '/terminal-preferences/customer-facing-display',

    PRICE_LISTS = '/price-lists',
    PRICE_LISTS_MAIN = '/price-lists/price-lists',
    PRICE_LISTS_NEW = '/price-lists/price-lists/new',
    PRICE_LISTS_EDIT = '/price-lists/price-lists/:id',

    TOTAL_SALE_DASHBOARD = '/dashboard',

    ORDER_DASHBOARD = '/order-dashboard',
    ORDER_DASHBOARD_DETAIL = '/order-dashboard/:orderId',

    REQUEST_RESET_PASSWORD = '/request-reset-password',
    RESET_PASSWORD = '/reset-password',
    MY_ACCOUNT = '/my-account',

    ORDER_QUEUES = '/order-queues',
    CHECK_DEVICE = '/check-device',
    ORDERS = '/orders/:id',

    CUSTOMER_FACING_DISPLAY = '/cfd',
    DOCUMENT = '/docs/:category/:docTitle',
}

export default ROUTE
